var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "해시태그",
      fn: function fn() {
        return [_c('v-autocomplete', {
          class: "form-baseinfo-hashTags-".concat(_vm.className),
          attrs: {
            "items": _vm.hashTags,
            "menuProps": {
              attach: ".form-baseinfo-hashTags-".concat(_vm.className)
            },
            "attach": "",
            "multiple": "",
            "small-chips": "",
            "outlined": ""
          },
          on: {
            "input": _vm.emit,
            "change": _vm.emit
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function fn(_ref) {
              var item = _ref.item;
              return [_c('v-chip', {
                staticClass: "grey-9--text ma-2 ma-lg-4",
                attrs: {
                  "outlined": "",
                  "small": "",
                  "label": "",
                  "color": "grey-d"
                }
              }, [_vm._v(_vm._s(item))])];
            }
          }]),
          model: {
            value: _vm.form.hashTags,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "hashTags", $$v);
            },
            expression: "form.hashTags"
          }
        })];
      },
      proxy: true
    }, {
      key: "접수기간",
      fn: function fn() {
        return [_c('form-baseinfo-application', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.application,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "application", $$v);
            },
            expression: "form.application"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }